import classes from "../classes";
import findBet from "../find-bet";
import { Link } from "react-router-dom";
import pure from "./higher-order/pure";
import RaceCountdown from "./race-countdown";
import React from "react";
import TournamentStats from "./tournament-stats";
import TowelIcon from "./towel-icon";

export default pure(function MyGamesFeed({ bets, myTickets, raceEntrants, races, tokenTypes, tournament, tournaments }) {
  var items = tournaments.map((t) => (
    <MyGamesFeedItem
      active={tournament && tournament.get("id") === t.get("id")} // eslint-disable-line react/jsx-no-leaked-render
      bets={bets}
      key={t.get("id")}
      myTickets={myTickets}
      raceEntrants={raceEntrants}
      races={races}
      tokenTypes={tokenTypes}
      tournament={t} />
  ));

  if (tournaments.count() === 0) {
    items = <MyGamesFeedEmpty tournament={tournament} />;
  }
  return (
    <div className="game-feed">
      <ul className="game-feed_list">
        {items}
      </ul>
    </div>
  );
});

var MyGamesFeedEmpty = pure(function MyGamesFeedEmpty({ tournament }) {
  var cta;
  if (tournament) {
    cta = ((
      <Link className="btn btn--small" to="/">
        Browse Tournaments
      </Link>
    ));
  }
  return (
    <li className="game-feed_item">
      <div className="game-feed_link game-feed_link--mock">
        <p>
          No games scheduled today.
        </p>

        <p>
          Pick a game. Pick your horses. Win today!
        </p>

        {cta}
      </div>
    </li>
  );
});

var MyGamesFeedItem = pure(function MyGamesFeedItem({ active, bets, myTickets, raceEntrants, races, tokenTypes, tournament }) {
  myTickets = myTickets.valueSeq().filter((ticket) => ticket.get("tournament_id") === tournament.get("id"));

  var tournamentRaces = tournament.get("races").map((raceId, i) => races.get(raceId).set("tournament_race_number", i + 1));
  var nextRace = tournament.get("nextRace");

  if (nextRace) {
    nextRace = tournamentRaces.find(tr => tr.get("id") === nextRace.get("id"));
  }
  return (
    <li className="game-feed_item">
      <Link
        className={classes({
          "game-feed_link": true,
          "game-feed_link--is-active": active
        })} to={"/tournaments/" + tournament.get("id")}>
        <div className="game-feed_title">
          {tournament.get("name")}
        </div>

        <MyGamesFeedItemNextRace race={nextRace} tournamentRaces={tournamentRaces} />

        <MyGamesFeedItemTickets bets={bets} myTickets={myTickets} race={nextRace} raceEntrants={raceEntrants} tournament={tournament} />

        <TournamentStats myTickets={myTickets} races={races} tokenTypes={tokenTypes} tournament={tournament} />
      </Link>
    </li>
  );
});

var MyGamesFeedItemNextRace = pure(function MyGamesFeedItemNextRace({ race, tournamentRaces }) {
  if (race === undefined) {
    return null;
  }
  return (
    <ul className="game-feed_meta">
      <li>
        <dl className="game-feed_dl">
          <dt>
            R
            {race.get("tournament_race_number")}
            /

            {tournamentRaces.count()}
            :

            {" "}
          </dt>

          <dd>
            {race.get("track_abbreviation")}
            -

            {race.get("race_number")}
          </dd>
        </dl>
      </li>

      <li>
        <dl className="game-feed_dl">
          <dd>
            <MyGamesFeedItemStatus race={race} />
          </dd>
        </dl>
      </li>
    </ul>
  );
});

var MyGamesFeedItemStatus = pure(function MyGamesFeedItemStatus({ race }) {
  if (race.get("status") === "running") {
    return (
      <span className="color--is-lime">
        <span className="dw-horse-running dw--1-25x" />

        <span className="game-summary_label">
          {" "}
          Running
        </span>
      </span>
    );
  }
  return <RaceCountdown race={race} />;
});


var MyGamesFeedItemTickets = pure(function MyGamesFeedItemTickets({ bets, myTickets, race, raceEntrants, tournament}) {
  return (
    <span>
      {myTickets
        .filter((ticket) => !ticket.get("eliminated_by_race_id"))
        .map((ticket) => <MyGamesFeedItemTicketDetails bets={bets} key={ticket.get("id")} race={race} raceEntrants={raceEntrants} ticket={ticket} tournament={tournament} />)}
    </span>
  );
});

var MyGamesFeedItemTicketDetails = pure(function MyGamesFeedItemTicketDetails({ bets, race, raceEntrants, ticket, tournament }) {
  if (race === undefined) {
    return null;
  }

  var score = ticket.get("score");

  var rankedTicket = tournament.get("rankedTickets").find((t) => t.get("id") === ticket.get("id"));
  var rank = "";
  if (rankedTicket) {
    var myRank = rankedTicket.get("rank") || "1";
    rank = myRank + "/" + tournament.get("rankedTickets").count();
  }

  var ticketClass = "game-feed_ticket";

  var bet = findBet(bets, race.get("id"), ticket.get("id"));

  if (tournament.get("tournament_type") === "Survivor") {
    score = Math.floor(score);
    if (score === 1) {
      score += " Win";
    } else {
      score += " Wins";
    }
    rank = "Survivor!";
    ticketClass = ticketClass + " game-feed_ticket--is-winner";
  }

  return (
    <ul className="game-feed_ticket-table">
      <li>
        <span className={ticketClass} data-ticket-number={ticket.get("ticket_number")} >
          <i className="dw-ticket-solid" />
        </span>
      </li>

      <li>
        <span className="text--is-bold">
          {rank}
        </span>
      </li>

      <MyGamesFeedItemTicketDetailsBet bet={bet} raceEntrants={raceEntrants} />

      <li>
        {score}
      </li>
    </ul>
  );
});

var MyGamesFeedItemTicketDetailsBet = pure(function MyGamesFeedItemTicketDetailsBet({ bet, raceEntrants }) {
  if (bet === undefined) {
    return (
      <li>
        <span className="dw-warning5 dw--1-25x color--is-medium-gray" />

        <span>
          {" "}
          No Pick
        </span>
      </li>
    );
  } else if (bet.get("race_entrant_id") === null) {
    return (
      <li>
        <span className="dw-star_outline dw--1-5x color--is-medium-gray" />

        <span>
          {" "}
          PTF
        </span>
      </li>
    );
  } else {
    var entrant = raceEntrants.get(bet.get("race_entrant_id"));
    if (!entrant) {
      return null;
    }
    return (
      <li>
        <TowelIcon lane={entrant.get("lane_number")} small />

        <span>
          {" "}

          {entrant.get("morning_line")}
        </span>
      </li>
    );
  }
});
